import React, { useContext } from "react";
import ReactPlayer from 'react-player';
import { LanguageContext } from "../context/LanguageContext"

const VideoComponent = () => {

const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

  return (
    <div className="player-wrapper">
      <ReactPlayer
        url={t('video1')}
        className="react-player"
        playing={false}
        controls={true}
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default VideoComponent;
